export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14894.56e0e52f.jpg";